export default __webpack_public_path__ + "static/media/laptop4.36b7e483.jpeg";